/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OpportunityType = {
    Repatriation: 'REPATRIATION',
    DirectQuote: 'DIRECT_QUOTE',
    Sourcing: 'SOURCING',
    Search: 'SEARCH'
} as const;
export type OpportunityType = typeof OpportunityType[keyof typeof OpportunityType];


export function instanceOfOpportunityType(value: any): boolean {
    for (const key in OpportunityType) {
        if (Object.prototype.hasOwnProperty.call(OpportunityType, key)) {
            // @ts-ignore
            if (OpportunityType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OpportunityTypeFromJSON(json: any): OpportunityType {
    return OpportunityTypeFromJSONTyped(json, false);
}

export function OpportunityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityType {
    return json as OpportunityType;
}

export function OpportunityTypeToJSON(value?: OpportunityType | null): any {
    return value as any;
}

